function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_105553161644384",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1581",
  "data-name": "Path 1581",
  d: "M17.792,6.255a6.261,6.261,0,1,0-6.255,6.267A6.256,6.256,0,0,0,17.792,6.255Zm-1.97,0a4.361,4.361,0,0,0-4.285-4.427A4.353,4.353,0,0,0,7.252,6.255a4.356,4.356,0,0,0,4.285,4.439A4.364,4.364,0,0,0,15.822,6.255Z",
  transform: "translate(0.985)",
  fill: "#f86542",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1582",
  "data-name": "Path 1582",
  d: "M22.136,14.612a21.538,21.538,0,0,0-9.614-2.552,21.538,21.538,0,0,0-9.614,2.552A5.384,5.384,0,0,0,0,19.4v.819A2.568,2.568,0,0,0,2.552,22.79H22.481a2.571,2.571,0,0,0,2.564-2.576V19.4a5.384,5.384,0,0,0-2.908-4.783Zm.926,5.614a.771.771,0,0,1-.748.8H2.73a.781.781,0,0,1-.76-.8v-.819a3.64,3.64,0,0,1,1.911-3.217,19.072,19.072,0,0,1,8.641-2.362,19.072,19.072,0,0,1,8.641,2.362,3.629,3.629,0,0,1,1.9,3.217v.819Z",
  transform: "translate(0 2.254)",
  fill: "#f86542",
  fillRule: "evenodd"
}));

var SvgIconPersonOutline = function SvgIconPersonOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_x0020_1",
    width: 25.044,
    height: 25.044,
    viewBox: "0 0 25.044 25.044",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPersonOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-person-outline.4ebe2162.svg";
export { ForwardRef as ReactComponent };